import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { features } from '../../data/features';
import { SectionHeading } from '../SectionHeading';
export function WhyChoose() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white" aria-labelledby="why-heading" data-id="element-229" data-mp="3sy0kbeu74zpo">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24" data-id="element-230" data-mp="u818cfgfnea">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-231" data-mp="wlxgolvf5nf">
          <div className="lg:sticky lg:top-32 lg:self-start" data-id="element-232" data-mp="3j7fou09tkbaz">
            <SectionHeading id="why-heading" eyebrow={t({
            en: 'Why M&S Multiservices',
            es: 'Por qué M&S Multiservices'
          })} title={t({
            en: 'The contractor your neighbors actually recommend',
            es: 'El contratista que tus vecinos realmente recomiendan'
          })} description={t({
            en: 'Ten years of work in Dallas-Fort Worth built on the same three things: show up when we said, do the work right the first time, and leave the house cleaner than we found it.',
            es: 'Diez años de trabajo en Dallas-Fort Worth basados en lo mismo: llegar cuando prometemos, hacer el trabajo bien desde la primera vez, y dejar la casa más limpia de como la encontramos.'
          })} data-id="element-233" data-mp="3nzqmsxl01n0w" />
          </div>

          <ul className="grid gap-x-10 gap-y-px sm:grid-cols-2" data-id="element-234" data-mp="3u8vmjb4xdkf3">
            {features.map(feature => <li key={feature.title.en} className="border-t border-navy/10 py-7" data-id="element-235" data-mp="36j1auwwce1wf">
                <feature.icon className="h-7 w-7 text-gold-dark" aria-hidden="true" data-id="element-236" data-mp="31kzpu6fcvsib" />
                <h3 className="mt-4 font-display text-xl text-navy" data-id="element-237" data-mp="3g9mh96i9capw">{t(feature.title)}</h3>
                <p className="mt-2 leading-relaxed text-ink/75" data-id="element-238" data-mp="3bhkw0v3439nq">{t(feature.description)}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}